import React from 'react';
import { Modal } from '../../Modal';
import { FieldForm } from './FieldForm';
export var FieldFormModal = function FieldFormModal(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 'small' : _props$size;
  return React.createElement(Modal, {
    show: true,
    widthSize: size,
    onClose: props.onClose
  }, React.createElement(FieldForm, props));
};